import { ISafetyCaseValues } from './safety-case-form-types'
import {
  ISafetyCase,
  ISafetyCaseAddUpsert,
  ISafetyCaseUpdateUpsert,
  IGeoJson,
  ITag,
} from '../../../../interfaces'

export const safetyCaseToSafetyCaseValues = (
  safetyCase: ISafetyCase | undefined,
): ISafetyCaseValues | undefined => {
  if (!safetyCase) {
    return undefined
  }

  return {
    name: safetyCase?.name,
    description: safetyCase?.description,
    statusId: safetyCase?.parentStatus.id,
    tagIds: safetyCase?.tags?.map((tag: ITag) => tag.id),
  }
}

export const safetyCaseValuesToSafetyCaseAddUpsert = (
  safetyCaseValues: ISafetyCaseValues,
  payload: { geoJson?: IGeoJson; airportId: number },
): ISafetyCaseAddUpsert | undefined => {
  if (!safetyCaseValues) {
    return undefined
  }

  return {
    id: 0,
    airportId: payload?.airportId,
    name: safetyCaseValues?.name,
    description: safetyCaseValues?.description,
    statusId: safetyCaseValues?.statusId,
    completed: false,
    tagIds: safetyCaseValues?.tagIds,
    geometry: payload?.geoJson && {
      type: String(payload.geoJson.geometry.type),
      coordinates: JSON.stringify(payload.geoJson.geometry.coordinates),
    },
  }
}

export const safetyCaseValuesToSafetyCaseUpdateUpsert = (
  safetyCaseValues: ISafetyCaseValues,
  payload: { safetyCase: ISafetyCase; geoJson?: IGeoJson },
): ISafetyCaseUpdateUpsert | undefined => {
  if (!safetyCaseValues) {
    return undefined
  }

  return {
    id: payload.safetyCase.id,
    airportId: payload.safetyCase?.airportId,
    name: safetyCaseValues?.name,
    description: safetyCaseValues?.description,
    statusId: safetyCaseValues?.statusId,
    completed: false,
    tagIds: safetyCaseValues?.tagIds,
    geometry: payload?.geoJson && {
      type: String(payload.geoJson.geometry.type),
      coordinates: JSON.stringify(payload.geoJson.geometry.coordinates),
    },
  }
}
